/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import plusIcon from '05Images/plusIcon.svg'
import crossicon from '05Images/crossicon.svg';
import people from '05Images/people.svg';
import trash from '05Images/trashBox.svg';
import edit from '05Images/pencil.svg'
/* ====== Component Js/Jsx ====== */
import { TableSelectB } from "./TableSelect";
import { InputTimeField } from "../InputParts/InputTimeField";
import { assets } from '03CommonApiParts/Configuration';
// import { CFArrayGetKey,CFArrayFount,CFFileUpload,CFStingMasterEdit, CFDateTimeFormatEdit } from "03CommonApiParts/CommonFunction";
import { CFArrayFount,CFStingMasterEdit, CFDateTimeFormatEdit, CFDateEdit } from "03CommonApiParts/CommonFunction";
import { Tooltip } from "02CommonUiParts/OtherParts/Tooltip";
import { TableInputList } from "02CommonUiParts/TableParts/TableInputList";
import { TableInputField } from "02CommonUiParts/TableParts/TableInputField";
import { patternCheckMaster, inputCheckMaster } from "03CommonApiParts/CodeDefinition";
import { TableCheck } from "./TableCheck";
import { InputErrorMessage } from "./InputErrorMessage";
import { ButtonIconInsertRow } from "02CommonUiParts/ButtonParts/ButtonBase";
import { InputVariableListField } from "./InputVariableListField";
// import { useFieldArray, useWatch } from "react-hook-form";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------テーブル ------*/
const SdivTableGroup = styled.div`//テーブル外枠
	display: flex;
	-webkit-flex-wrap: wrap;
	flex-wrap: wrap;

`;
const SdivPaper = styled.div`//テーブル内枠
	border-radius: 3px;
	overflow-Y: auto;
	overflow-X: auto;
    border: 1px solid #c0c0c0;
    /* max-width:calc(100% - 10px); */
`;
const SdivInputTileLabel = styled.div`//入力項目のタイトル
    display:flex;
    align-items:center;
    justify-content:center;
    margin:0 0 12px 6px;
    height:32px;
    white-space: nowrap;
`;
const SdivLabelGroup =styled.div`//入力項目一つの枠
    /* display:flex;
    flex-wrap: wrap;
    align-items:center;
    margin-right:15px; */
	line-height:${`calc(${assets().size.baseText}+5px);`};
	padding:3px;
	margin: 0px;
`;
const SdivLabelWrapper = styled.div`
    height: 100%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    word-break:break-word;
	color:${props => props.color };
`;
const SlabelRequireMark = styled.label`
    display: flex;
    align-items: center;
    color: ${assets().color.orange};
    height: 12px;
`;
const Slabel = styled.label` //ラベル表示
    /* margin:0 0 14px 6px; */
    min-height:20px;
    display:flex;
    align-items: center;
    word-break: break-word;
`;
const Str = styled.tr`//テーブルの行
	z-index: ${props => props.header2 ? 38 : 39};
	background-color:${assets().color.blue};
    position: sticky;
    top: ${props=>props.header2 ? '40px': '0px'};
	height: 40px;
`;
const Sth = styled.th`//テーブルヘッダーセル
	overflow-wrap: break-word;
	margin: 0px;
    font-weight: bold;
	padding: 2px 4px;
	color: white;
    background-color:${assets().color.blue};
	top: 0;
	z-index: 20;
    text-align: left;
	position: sticky;
`;
const SdivSortLabel = styled.div`//thテキストラベル
    display: block;
    align-items: center;
    user-select:none;
    /* padding-left:10px; */
`;
const SlabelHead = styled.label`
    display: inline;
    line-height: 1.5em;
    /* width: 100%; */
`
const SdivFlex = styled.div`
	display: flex;
	align-items: center;
	height: 1.5rem;
`
/* ------テーブル内で表示するテーブル ------*/
// const StdSmallLeft = styled.td`//左セル
//     width: 15%;
//     border-bottom: solid 0.5px #D9D9D9;
//     border-top: solid 0.5px #D9D9D9;
//     padding: 0px 7px;
// `
const StdSmallRight = styled.td`//右セル
    padding-top:'10px';
	background-color: white;
	height:38px;
`;
const Stable = styled.table`//テーブル本体
	background-color: white;
    color:black;
    font-weight:normal;
	border-radius: 0px;
	border-spacing: 0;
    word-break: break-all;
	max-height: ${props => props.tableMaxHeight ? props.tableMaxHeight : 'calc(100vh - 100px)'};
    th, td{
        border-bottom: solid 0.5px #c0c0c0;
        border-left:  none;
        margin: 0;
        /* padding-left: 10px; */
    }
    tr:last-child td{
        border-bottom: none;
    }
    tr td:first-child, tr th:first-child{
        border-left: none;
    }
`;
const StrTableRow = styled.tr`//テーブルボディー行
    /* background-color:${props => props.closeCheck ? assets().color.tableDisabled : ''};
    &:hover{
    background-color:${props => props.closeCheck ? assets().color.tableDisabled : assets().color.backgroundBlue};
    }
    &:hover td{
    background-color:${props => props.closeCheck ? assets().color.tableDisabled : assets().color.backgroundBlue};
    } */
    background-color:white;
    	z-index:${props => props.tableBodyZindex ? props.tableBodyZindex : '20'};
    th:first-child{
    	padding-left: 6px;
    };
    td:last-child{
    	padding-right: 6px;
    }
    &:hover{
    	background-color:${props => props.hoverEffect ? assets().color.backgroundBlue : ''};
    	cursor: ${props => props.notAllowed ? 
			'not-allowed' 
		: props.hoverEffect ? 
			'pointer' 
		: 'default'};
    }
    &:hover td{
    	background-color:${props => props.hoverEffect ? assets().color.backgroundBlue : ''};
    }
	height: 40px;
`;
const SsvgTie = styled.svg` //SVG用
    width:${props => props.size? props.size:'15px'};
    height:${props => props.size? props.size:'15px'};
	cursor:pointer;
    ${props => props.disabled ?
        'pointer-events: none;'
    : ''
    }
    padding:0 3px;
`;
const SsvgIconButton = styled.svg` //SVG用
    cursor: pointer;
`;
/*==================*/
/*=====  Main  =====*/
/*==================*/

export const TableArray = (props) => {
    /* --------------------------- */
    /* --------- valiable -------- */
    /* --------------------------- */
    const { payload, register, errors, dataRow,paperStyle, headCells, headCells2, bodyCells,fieldsList,append,remove,payloadCategory, hoverEffect, showBottom, editMode, notShowSearchNumber, watch, changeEmployee, tableType, onClickAllCheck,onClickRegister,listMode,dragStart,dragEnter,dragEnd,payloadData, setValue, oldData, getValues, pageType, trigger} = props;
    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
	/* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
	let size = 12; //boderやpadding分があるので初期は12;
    /* テーブルサイズの計算 */
    headCells?.length > 0 && headCells.forEach((item)=>{
        size = size + Number(item.width.replace('px',''));
    });
    

	/* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
	return(
	<div>
		{/* テーブル外枠 */}
		<SdivTableGroup>
			<SdivPaper className={paperStyle ? 'tableSmallHeightsize' : 'tableHeightsize'} style={ paperStyle ? paperStyle : {maxHeight:assets().size.tableHeightsize}}>
				<Stable className='tableStyle' style={{width:size * assets().size.tableCell}}>
					<tbody>
						<TableHeader
								headCells={headCells}
								editMode={editMode}
								errors={errors}
								payload={payload}
								register={register}
								onClickAllCheck={onClickAllCheck}/>
						{headCells2 && 
							<TableHeader
								header2={true} 
								headCells={headCells2}
								editMode={editMode}
								errors={errors}
								payload={payload}
								register={register}
								onClickAllCheck={onClickAllCheck}/>}
						{fieldsList?.length > 0 && fieldsList.map((fields,fieldsIndex)=>{
							if(fields.acceptStop === true) return <></>;
							return(
								<StrTableRow 
									id='row'
									key={fields.id}
									draggable={	tableType === 'moveAll' ? 
										true 
									: tableType === 'moveOnlyChecked' ? 
										(fields.outputTarget ? true :false)
									:false}
									notAllowed={(tableType === 'moveOnlyChecked' && !fields.outputTarget) ? true : false}
                                    onDragStart={(e) => dragStart(e,fieldsIndex)}
									onDragEnter={()=>dragEnter(fieldsIndex)}
                                    // onDragEnter={(event) => !flag ? dragEnter(event, fieldsIndex) : null}
                                    onDragOver={(event) => event.preventDefault()}
									onDrop={() => dragEnd(fieldsIndex)}
                                    hoverEffect={hoverEffect}
                                    childBackGroundColor={fields.acceptStop}
									>
									{bodyCells?.length > 0 && bodyCells.map((col,colIndex)=>(
										<StdSmallRight 
											justifyContent={col.align}
											className='baseText'
											style={{ 
												fontSize:assets().size.baseText, 
												textAlign: col.align, 
												color: col.color,
												position: col.fixed ? 'sticky' : '',
												left: col.left ? Number(col.left?.replace('px', '')) * assets().size.tableCell : '', 
												zIndex: '29',
												borderRight: col.borderRight,
												borderLeft: col.borderLeft,
											}}
											key={colIndex}>
											<SdivLabelGroup style={{alignItems:'start'}}>
												{col.type === 'input' ?
													<TableInputField
														isDirty={
															(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : null) 
															!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : null)
														}
														disabled={col.disabled}
														width={col.width}
														placeholder={col.placeholder}
														readOnly={fieldsList?.[fieldsIndex]?.readOnly?.find((str) => str === col.name) || col.readOnly}
														register={register(`${payload}.${payloadCategory}[${fieldsIndex}.${col.name}]`,
														{
															required: col.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',  
															minLength: { value:col.minLength?col.minLength:null,message:CFArrayFount(inputCheckMaster.list,'value','min').label}, 
															maxLength: { value:col.maxLength?col.maxLength:null,message:CFArrayFount(inputCheckMaster.list,'value','max').label}, 
															pattern: {
																		value: col.pattern ? CFArrayFount(patternCheckMaster.list,'value',col.pattern).detailItemValidationTypeCode:CFArrayFount(patternCheckMaster.list,'value','space').detailItemValidationTypeCode,
																		message: col.pattern ? CFArrayFount(patternCheckMaster.list,'value',col.pattern).label:CFArrayFount(patternCheckMaster.list,'value','space').label
																	}
														})}
														/>
												: col.type === 'inputList' ?
												<TableInputList
													list={col.name}
													isDirty={
														(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : null) 
														!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : null)
													}
													title={col.title}
													disabled={payloadData?.[fieldsIndex]?.[col.checkItem] !== col.checkValue ? true : col.disabled ? true : false}
													readOnly= {col.check && col.checkValue.includes(watch?.[fieldsIndex]?.[col.checkItem]) ? true : col.readOnly}
													range={col.master.list} //選択肢
													maxLength={col.maxLength}
													width={col.width}
													defaultValue={dataRow?.[col.name]}
													rightLabel={col.rightLabel}
													placeholder={col.placeholder}
													onClickDatalist={changeEmployee}
													register={register(`${payload}.${payloadCategory}[${fieldsIndex}.${col.name}]`,
														{
															required:payloadData?.[fieldsIndex]?.[col.checkItem] !== col.checkValue ? '' : col.disabled ? '' : CFArrayFount(inputCheckMaster.list, 'value', 'required').label,
															minLength: { value: col.minLength ? col.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
															maxLength: { value: col.maxLength ? col.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
															pattern: {
																value: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
																message: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
															},
															validate:{
																invalidData: v => {
																	if(v){
																		if(!v)return;
																		/* disabledの時は関係なし */
																		if(payloadData?.[fieldsIndex]?.[col.checkItem] !== col.checkValue ? true : col.disabled ? true : false)return;
																		if(col.noValidation) return;
																		let inputValue = v.split(' ')?.[0];
																		let inputName = v.substr(inputValue.length + 1);
																		/* リストに存在しない値を入力していた場合はエラー表示 */
																		if(!CFArrayFount(col.master.list,'value',inputValue) || !CFArrayFount(col.master.list,'label',inputName)){
																			return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
																		}
																	}
																	
																}
															},
															onChange: (e) => col.onChange && col.onChange(e)
														})}
												/>
												: col.type === 'inputVariableList'?
												<>
												 <InputVariableListField
												 	isDirty={
														(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : null) 
														!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : null)
													}
												    errorMessage={errors[payload]?.[payloadCategory]?.[fieldsIndex]?.[col.name]?.message}
												    title={col.title}
												    name={`${payload}.${payloadCategory}.${fieldsIndex}.${col.name}`}
												    disabled={payloadData?.[fieldsIndex]?.[col.checkItem] && (payloadData?.[fieldsIndex]?.[col.checkItem]!== col.checkValue ? true : col.disabled ? true : false) }
												    readOnly={col.readOnly}
												    maxLength={col.maxLength}
												    width={col.width}
												    rightLabel={col.rightLabel}
												    placeholder={col.placeholder}
												    range={col.master}
												    list={col.name}
												    id={`${payload}.${payloadCategory}.${fieldsIndex}`}
													fields={payloadData?.[fieldsIndex]}
												    onClickButton={col.onClickButton}
												    register={register}
													setValue={setValue}
													value={fields[col.name]}
													trigger={trigger}
													/>
												</>
												: col.type === 'check' ?
													<>
													<TableCheck
														id={col.name}
														isDirty={
															(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : false) 
															!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : false)
														}
														disabled={
															!editMode ||  col.disabled
														}
														errorMessage={errors[payload]?.[fieldsIndex]?.[col.name]?.message}
														scale={col.scale}
														labelId={`${payload}.${payloadCategory}.${fieldsIndex}.${col.name}`}														
														register={register(`${payload}.${payloadCategory}.${fieldsIndex}.${col.name}`,
															{
																value:fields[col.name],
																onChange:e=>{
																	col.func?.(e, fieldsIndex, {...fields, [col.name]: e.target.checked});
																	return;
																},
																required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
															})}
													/>
													</>
												:col.type === 'select' ?
													<>
														{col.title?<SdivInputTileLabel >{col.title}</SdivInputTileLabel>:<></>}
														<TableSelectB
															isDirty={
																(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : null) 
																!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : null)
															}
															boxStyle={{justifyContent:'left'}}
															register={register(`${payload}.${payloadCategory}[${fieldsIndex}.${col.name}]`,
															{
																value:fields[col.name] ? fields[col.name]:col.defaultValue,
																required: col.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
																onChange: (e) => {
																	col.changeFunc && col.changeFunc(fieldsIndex, e.target.value);
																	return;
																}
															})}
															noHidden={!col.required}
															range={col.master.list} //選択肢
															disabled={col.disabled}
															readOnly={col.readOnly}
														/>
													</>                                        
												:col.type === 'date'? //日付表示
													// <SdivLabelGroup >
														<InputTimeField
															isDirty={
																(payloadData?.[fieldsIndex]?.[col.name]? payloadData?.[fieldsIndex]?.[col.name] : null) 
																!== (dataRow?.[payloadData[fieldsIndex].id]?.[col.name] ? dataRow?.[payloadData[fieldsIndex].id]?.[col.name] : null)
															}
															register={register(`${payload}.${payloadCategory}[${fieldsIndex}.${col.name}]`,
															{
																value:fields[col.name] ? fields[col.name]:col.defaultValue,
																required: col.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
																pattern: {
																	value: col.pattern ? 
																		CFArrayFount(patternCheckMaster.list,'value',col.pattern).detailItemValidationTypeCode
																	:null,
																	message: col.pattern ? 
																		CFArrayFount(patternCheckMaster.list,'value',col.pattern).label
																	:null
																},
																validate:{
																	//startDateよりendDateが大きい場合にエラーを発生させる
																	invalidDate: v => {
																		if(col.startDate){                   
																		if(v && payloadData?.[fieldsIndex]?.[col.startDate]){
																			// v > startDate
																			if(new Date(v) > new Date(payloadData?.[fieldsIndex]?.[col.startDate])){
																				return true;
																			// v < startDate     
																			}else{
																				return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
																			}
																		};
																		}else if(col.endDate){
																			if(v && payloadData?.[fieldsIndex]?.[col.endDate]){
																				// endDate > v
																				if(new Date(payloadData?.[fieldsIndex]?.[col.endDate]) > new Date(v)){
																					return true;
																				// endDate < v   
																				}else{
																					return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
																				};                                                                                            
																			};
																		};
																	}
																}
															})}
															label={col.title}
															disabled={col.disabled}
															readOnly={fieldsList?.[fieldsIndex]?.readOnly?.find((str) => str === col.name) || col.readOnly}
															type='date'
														/>
													// </SdivLabelGroup>
													
												: col.type === 'dateLabel' ?//codeからlabelに直して表示
													<SdivLabelWrapper>
														{CFDateEdit(fields[col.name])}
													</SdivLabelWrapper>
												:col.type === 'timeLabel' ?//codeからlabelに直して表示
													<p style={{margin: '0'}}>
														{CFDateTimeFormatEdit(fields[col.name])?.split(/\s+/g,)[0]}
														<br />{CFDateTimeFormatEdit(fields[col.name])?.split(/\s+/g,)[1]}
													</p>
												:col.type === 'edit' ?//codeからlabelに直して表示
												<SdivLabelGroup>
													<SdivLabelWrapper>{CFStingMasterEdit(col.master,fields[col.name])}</SdivLabelWrapper>
												</SdivLabelGroup>
												:col.type === 'label' ?
												<SdivLabelGroup >
													<SdivLabelWrapper>{fields[col.name]}</SdivLabelWrapper>
													{fields.checkChangeFlag?.[col.name]?
														<>
															<SdivLabelWrapper>↓</SdivLabelWrapper>
															<SdivLabelWrapper color='red'>{fields[`${col.name}New`] }</SdivLabelWrapper>
														</>
														:<></>
													}
												</SdivLabelGroup>
												:col.type === 'numberLabel' ?
												<SdivLabelGroup >
													<SdivLabelWrapper>{fields[col.checkItem] === col.checkValue ? fieldsIndex + 1 : null}</SdivLabelWrapper>
													{fields.checkChangeFlag?.[col.name]?
														<>
															<SdivLabelWrapper>↓</SdivLabelWrapper>
															<SdivLabelWrapper color='red'>{fields[`${col.name}New`] }</SdivLabelWrapper>
														</>
														:<></>
													}
												</SdivLabelGroup>
												:col.type === 'dateLabel' ?//codeからlabelに直して表示
												fields[col.name] === '未入力' ?
												<SdivLabelGroup >
													<SdivLabelWrapper>{fields[col.name]}</SdivLabelWrapper>
													{fields.checkChangeFlag?.[col.name]?
														<>
															<SdivLabelWrapper >↓</SdivLabelWrapper>
															<SdivLabelWrapper color = 'red'>{CFDateEdit(fields[`${col.name}New`])} </SdivLabelWrapper>
														</>
														:<></>
													}
												</SdivLabelGroup>
												:
												<SdivLabelGroup >
													{CFDateEdit(fields[col.name])}
													{fields.checkChangeFlag?.[col.name]?
														<>
															<SdivLabelWrapper>↓</SdivLabelWrapper>
															<SdivLabelWrapper color = 'red'>{CFDateEdit(fields[`${col.name}New`])} </SdivLabelWrapper>
														</>
														:<></>
													}
												</SdivLabelGroup>
												:col.type === 'tablebutton' ?
												// setFields(fieldsList,dataRow).length === fieldsIndex+1 ?
												<Slabel>
													<SsvgTie style={{paddingLeft:'10px',paddingTop:'5px',color:'#92C9CC',width:'25px',height:'25px'}} onClick={()=>append({})}>
														<use xlinkHref={`${plusIcon}#plusIcon`}></use>
													</SsvgTie>
													<SsvgTie style={{paddingLeft:'10px',paddingTop:'5px',color:'#E3AFAF',width:'25px',height:'25px'}} onClick={()=>fieldsList.length > 1 ? remove(fieldsIndex) : null}>
														<use xlinkHref={`${crossicon}#crossicon`}></use>
													</SsvgTie>
												</Slabel>
												: col.type === 'deleteIcon' ? //削除ボタン
												<SsvgIconButton onClick={() => 
													remove(fieldsIndex)
												// (fieldsIndex > dataRow.length - 1)? remove(fieldsIndex) : update(fieldsIndex, {...fields, acceptStop: true})
												}
												className='svgStyle' 
												style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, color: assets().color.red }}>
													<use xlinkHref={`${trash}#trashBox`}></use>
												</SsvgIconButton>
												: col.type === 'editIcon' ? //編集ボタン
												<SsvgIconButton 
													onClick={()=>col.func(
														CFArrayFount(getValues('payload.list'), 'dptCd', fields.dptCd),// useFieldArrayによってidが変わってしまうため、payload内の同じdptCdのオブジェクトを検索して渡す
														getValues('payload'), 
														oldData,
														pageType
													)} 
													className='svgStyle' 
													style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, color: assets().color.green }}
												>
													<use xlinkHref={`${edit}#pencil`}></use>
												</SsvgIconButton>
												: col.type === 'authorityChangeButton' ? //ユーザボタン
												<div style={{color:'red'}}>
													<SsvgIconButton 
														onClick={()=>col.func(fields)} 
														className='svgStyle'
														style={{ 
															height: assets().size.svgHeight, 
															width: assets().size.svgWidth, 
															color: col.checkItem ? fields[col.checkItem] === col.checkValue ? assets().color.disabled : assets().color.blue : assets().color.blue,
															pointerEvents:col.checkItem ? fields[col.checkItem] === col.checkValue ? 'none' : '' : '' }}>
													<use xlinkHref={`${people}#people`}></use>
													</SsvgIconButton>
												</div>
												:<></>}
												{errors[payload]?.[payloadCategory]?.[fieldsIndex]?.[col.name]?.message && <InputErrorMessage errorMessage={errors[payload]?.[payloadCategory]?.[fieldsIndex]?.[col.name]?.message}/>}
											</SdivLabelGroup>
										</StdSmallRight>
									))}
								</StrTableRow>
							)
						})}
					</tbody>
				</Stable>
		</SdivPaper>
	</SdivTableGroup>
	{showBottom &&
		<div className='baseText' style={{ fontSize: assets().size.baseText}}>
			{notShowSearchNumber ?
				<div></div>
				:  
				<div>検索件数:{fieldsList?.length}件</div>
			}
			{editMode &&<div style={{margin: '3px 0px 0 0px'}}>
				{listMode !== 'noneListEdit' ?
					// リスト上で編集する場合はappendを行う
					<ButtonIconInsertRow 
						onClick={
						(event) => {
							event.preventDefault();
							const appendData = {};
							appendData.id = 'new';
							append(appendData);
						}}/>
					:
					// リスト上で編集しない場合は送られてきた関数を実行する(部署マスタの場合は画面遷移)
					<ButtonIconInsertRow onClick={() => onClickRegister(
						getValues('payload'), 
						oldData, 
						pageType
					)}/>
				}
			</div>
			}
		</div>
	}
	</div>
	)
};



const TableHeader = (props) =>{
	const {header2,headCells,editMode,errors,payload,register,onClickAllCheck} = props;
	return(
		<Str header2={header2}>
		{headCells.map((headCell, headIndex)=>(
			<Sth 
				key={headIndex} 
				// className='tableCellStyle'
				className='baseText'
				colSpan={headCell.colspan}
				rowSpan={headCell.rowSpan}
				style={{
					width:Number(headCell.width.replace('px','')) * assets().size.tableCell,
					justifyContent: headCell.align,
					backgroundColor:headCell.backgroundColor,
					color:headCell.color,
					top: 0,
					zIndex: headCell.fixed ? '31' : '',
					left: headCell.left ? Number(headCell.left?.replace('px', '')) * assets().size.tableCell : '',
					borderRight: headCell.borderRight,
					borderLeft: headCell.borderLeft ,
					borderBottom:'none',
					whiteSpace: headCell.nowrap ? 'nowrap' : 'normal',
				}}
			>
				<SdivSortLabel style={{
					justifyContent: headCell.align, 
					fontSize: assets().size.baseText, 
					whiteSpace: headCell.nowrap ? 'nowrap' : ''}} className='baseText'
				>
					<div style={{
						display: 'flex',
						justifyContent: headCell.align1 ? headCell.align1 : headCell.align, 
						alignItems: 'center'
					}}>
						<div style={{
							textAlign: headCell.align1 ? headCell.align1 : headCell.align, 
						}}>
							<SdivFlex>
								<SlabelHead>
									{headCell.label1}
								</SlabelHead>
							</SdivFlex>
							{headCell.label2 === undefined ? <></> : <><SlabelHead>{headCell.label2}</SlabelHead></>}
						</div>
						{(headCell.required && editMode) &&
							<SlabelRequireMark>＊</SlabelRequireMark>
						}
						<Tooltip
							mark={true}
							exp={headCell.exp}
							baloonPosition={'30px'}
						/>
					</div>
				</SdivSortLabel>
				{ headCell.check ?
					<TableCheck
						id={headCell.name}
						disabled={headCell.disabled}
						errorMessage={errors[payload]?.[headCell.checkId]?.message}
						defaultChecked={headCell.defaultChecked}
						register={register(`tableCheck.${headCell.checkId}`,
							{
								onChange:(e) => onClickAllCheck(e),
								validate:{
									outsideDifined: e => {
										headCell.validate && (headCell.validate(e));
									}
								}
							})
						}/>
					:<></>                                       
				}
			</Sth>
		))}
		</Str>
	)
}

//使い方

//  /****** テーブルの設定　*****/
//     /*------ ヘッダの設定 ------*/
//     // id       : 項目名
//     // rowSpan  : 2~ (縦に結合)
//     // colSpan	: 2~ (横に結合)
//     // align	: 整列(横方向) Center/inherit/justify/left/right
//     // left		: 左からの位置	0~
//     // right	: 右からの位置 0~
//     // width    : セルの幅
//     // label1	: 表示名(1段目)
//     // label2	: 表示名(2段目)

	// const headDataMoveIn =[
	// 	{ id: 'moveInDate', align: 'left', width: '150px', sortTable:true, label1:'転入日'},//転入日
	// 	{ id: 'pledgeData', align: 'left', width: '150px', sortTable:true, label1: '誓約書提出日'},//誓約書提出日
	// 	{ id: 'generalApplication', align: 'left', width: '150px', sortTable:true, label1: '汎用申請番号'},//汎用申請番号
	// 	{ id: 'remarks', align: 'left', width: '200px', sortTable:false, label1: '備考'},//備考
	// 	{ id: 'lastUpdateBy',id2: 'lastUpdate', align: 'left', width: '120px', sortTable:true, label1: '最終更新者',label2: '最終更新日'},//最終更新
	// 	{ id: 'funcButton', align: 'left', width: '50px', sortTable:false},//ファンクションボタン
	// ]; 
//     /*------ BodyCellの設定　 ------*/
//     // name		    : 項目名
//     // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
//     // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
//     // width        : selectの幅調整用
//     // color        : 文字の色
//     // backgroundColor: 背景の色
//     // checkBox     : チェックボックスの名前  *input,checkBox
//     // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
//     // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
//     // func         : 処理 *button,iconButton,select
//     // value		: btnFuncで受け取りたい値 *button,iconButton

	// const bodyDataMoveInUpdate = [
	// 	{ name: 'moveInDate', type: 'input',  align: 'left'},
	// 	{ name: 'pledgeData', type: 'input', align: 'left'},
	// 	{ name: 'generalApplication', type: 'input', align: 'left'},
	// 	{ name: 'remarks', type: 'input', align: 'left'},
	// 	{ name: 'lastUpdateBy', name2: 'lastUpdate',  type: 'input', align: 'left',},
	// 	{ name: 'funcButton', type: 'tablebutton', align: 'left'},
	// ];

//     //ダミーデータ
// const dummyMoveIn = {
//     "metadata":{
//         "count":1
//     },
//     "payload":[
//         {
//         "moveInDate":"2021-04-01",
// 		"remarks":"就業時間は9:00~18:00",
// 		"pledgeData":"2021-04-01",
// 		"generalApplication":"WWWWW88888",
//         "lastUpdateBy":"山田太郎",
//         "lastUpdate":"2022-12-1",
//     },
// ]
// };

		/* <TableArray
		headCells={displayState === 'get' ? headDataMoveIn :headDataMoveInUpdate} //ヘッダの設定情報
		bodyCells={displayState === 'get' ? bodyDataMoveIn :bodyDataMoveInUpdate} //ボディの設定情報
		dataRow={moveInData} 
		tableSize={'700px'}
		paperStyle={{maxHeight:'calc(50vh - 250px)'}}
		searchNumber='none'
		fieldsList={MoveInFields}
		append={MoveInAppend}
		remove={MoveInRemove}
		getValues={getValues}
		register={register}
		payload='payload.movein'
		error={errors}/> */

		/*------ hook-formの設定　 ------*/
		// const { fields:MoveInFields, append:MoveInAppend, remove:MoveInRemove } = useFieldArray(
		// 	{
		// 		control,
		// 		name: "payload.movein"
		// 	}
		// );